export default __webpack_public_path__ + "static/media/setPaper.2aeeade6.png";